import React, { useEffect, useState } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { parse } from "query-string";
import I18n from "../../I18n";
import { mapProperties } from "colbi_web_ui/lib/utils";
import {
    logout,
    pushModal,
    pushDialog,
    popModal,
    toggleMenu,
    setLocale,
    removeModal,
    saveTranslationDetails,
    deleteTranslationDetailsRowAction,
    getTranslationBuilderCombinationsStats,
    applyRelatedEntitiesAction,
} from "../../store/actions";

import { LoadingIndicator } from "colbi_web_ui/lib/components";
import { SovosPageLayout, SovosPageContentGeneric } from "mosaic-react";
import ModalController from "../App/ModalController/ModalController";

import styles from "./TranslationTableDetails.module.sass";

import {
    decodeUserSession,
    redirectNotValid,
    BuildSovosNavProps,
} from "../../utils/utils";
import GlobalLayout from "../../components/GlobalLayout/GlobalLayout";
import { useAuth } from "react-oidc-context";
import { SovosSnackbar } from "mosaic-react";
import { onRowUpdateError } from "../RawData/utils";
import {
    buildSettingsStaticLinks,
    generateSettingsMenuItems,
} from "../../components/GlobalLayout/menuBuilderUtils";

const TranslationTableDetails = (props) => {
    const { user, fetch, match, setLocale, location, history, route, modules } = props;
    const locale = match.params.locale || "en";
    const defaultNotification = { open: false, message: "", type: "", onClose: () => {} };
    const [notification, pushNotification] = useState({ ...defaultNotification });

    const translationId = match.params.id;
    const i18n = I18n.use(locale);
    const translationTableInfo =
        fetch?.results[
            `${locale}_translation_table_isDuplicateMode_false_translationTableId_${translationId}`
        ] || {};

    const auth = useAuth();

    useEffect(() => {
        setLocale(locale);
    }, [locale, setLocale]);

    const userInformation = decodeUserSession(user);

    const menuItems = generateSettingsMenuItems(userInformation?.role, history, locale, i18n) || [];
    
    const navigation = menuItems;

    const setupLinks = buildSettingsStaticLinks(navigation, history, match.params, i18n);

    const redirect = redirectNotValid(userInformation, locale, true, auth);

    if (redirect) {
        return redirect;
    }
    
    if (!(userInformation && userInformation.accessSettings)) {
        return <Redirect to={`/${locale}/unauthorized`} />;
    }

    navigation.forEach((elem) => {
        elem.name = I18n.translate`${elem.name}`;
        return elem;
    });

    const queryParams = parse(location.search) || {};
    const routeParams = match.params || {};
    const params = {
        ...queryParams,
        ...routeParams,
    };

    const routeQueries = (route.queries && route.queries(params)) || [];

    let displayComponents = [];

    displayComponents.push(...route.components);

    const children = displayComponents.map((c, index) => {
        const Component = c.component;
        const componentParsedProps = mapProperties(
            c.props,
            (fetch || {}).results,
            (fetch || {}).status,
            routeQueries,
            props,
            params,
            i18n,
            locale,
        );
        const componentProps = {
            ...componentParsedProps,
            modules,
            translationTableInfo,
        };

        if (componentProps && componentProps.onRowEdit) {
            componentProps.onProcessRowUpdateErrorAction = () =>
                onRowUpdateError(pushNotification, I18n);
        }

        return (
            <Component
                key={index}
                modifiers={c.modifiers}
                {...componentProps}
                activity={fetch.activity}
            />
        );
    });

    const navProps = BuildSovosNavProps(
        undefined,
        [],
        { name: "" },
        {},
        userInformation,
        setupLinks || [],
    );

    const globalLayoutProps = {
        ...props,
        navProps,
        params,
        staticLinks: setupLinks,
        styles,
    };

    return (
        <GlobalLayout {...globalLayoutProps}>
            <SovosPageLayout 
                pageTitle={i18n`translation_table` + ` ${translationTableInfo?.name}`}
            >
                <SovosPageContentGeneric sx={{ padding: '0 !important', marginLeft: '24px', marginRight: '24px' }}>
                    <>
                        {fetch.activity && (
                        <LoadingIndicator className={`${styles["loading-indicator"]}`} />
                        )}
                        {children}
                        <SovosSnackbar
                        onClose={() => {
                            pushNotification({
                            ...notification,
                            open: false,
                            });
                        }}
                        message={notification && notification.message}
                        open={notification && notification.open}
                        variant={
                            notification && notification.type
                            ? notification.type
                            : "confirmation"
                        }
                        timeout={
                            notification && notification.timeout
                            ? notification.timeout
                            : "medium"
                        }
                        disableWindowBlurListener
                        />
                        <ModalController />
                    </>
                </SovosPageContentGeneric>
            </SovosPageLayout>
        </GlobalLayout>
    );
};

TranslationTableDetails.queries = (args) => {
    return [
        {
            resource: "translation_table",
            args: {
                translationTableId: +args.id,
                isDuplicateMode: "false",
            },
            body: "__typename, name, entity, datasetLocale, organizationId, id, delimiter",
        },
    ];
};

export default connect(
    ({ user, fetch, menu, uploads }) => ({
        user,
        fetch,
        menu,
        uploads,
    }),
    {
        toggleMenu,
        logout,
        setLocale,
        pushModal,
        popModal,
        removeModal,
        pushDialog,
        saveTranslationDetails,
        deleteTranslationDetailsRowAction,
        getTranslationBuilderCombinationsStats,
        applyRelatedEntitiesAction,
    },
)(withRouter(TranslationTableDetails));
